import { render, staticRenderFns } from "./UserDetails_Section_Badges.vue?vue&type=template&id=42e5d0fe&scoped=true&"
import script from "./UserDetails_Section_Badges.vue?vue&type=script&lang=js&"
export * from "./UserDetails_Section_Badges.vue?vue&type=script&lang=js&"
import style0 from "./UserDetails_Section_Badges.vue?vue&type=style&index=0&id=42e5d0fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e5d0fe",
  null
  
)

export default component.exports